import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import PdpSharedDetailAttributeLink from './helpers/PdpSharedDetailAttributeLink';

// helpers
import get from 'lodash.get';

function PdpSharedDetailStyleOf({ item }) {
    const attributesStyle = get(item, 'attributes.style') || [];

    if (!attributesStyle.length) {
        return null;
    }

    return (
        <PdpSharedDetailAttributeLink
            item={item}
            dataTn="pdp-spec-style-of"
            attributes={attributesStyle}
        />
    );
}

PdpSharedDetailStyleOf.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailStyleOf, {
    item: graphql`
        fragment PdpSharedDetailStyleOf_item on Item {
            ...PdpSharedDetailAttributeLink_item
            attributes {
                style {
                    ...PdpSharedDetailAttributeLink_attributes
                }
            }
        }
    `,
});
